(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drain-heat-scale"] && !Shopify.designMode) return;
  try {
    let drainHeatOpener = null;
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-drain-heat-open]');
  const dialog = document.getElementById('drain-heat-dialog');
  if (!dialog) return;
  if (trigger) {
    event.preventDefault();
    drainHeatOpener = trigger;
    const rating = Number(trigger.dataset.drainHeatOpen);
    dialog.querySelectorAll('.drain-heat-lineup li').forEach((item, index) => {
      item.classList.toggle('is-selected', index + 1 === rating);
    });
    if (!dialog.open) dialog.showModal();
    return;
  }
  if (event.target.closest('[data-drain-heat-close]')) dialog.close();
});
document.addEventListener('close', (event) => {
  if (event.target.id === 'drain-heat-dialog' && drainHeatOpener?.isConnected) drainHeatOpener.focus();
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drain-product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
 const thumb = event.target.closest('[data-drain-media]');
 if (thumb) {
  const root=thumb.closest('#ProductSection');
  root.querySelectorAll('[data-drain-gallery] .product-single__media-item').forEach(item=>{
   const active=item.id==='ProductMediaDesktop-'+thumb.dataset.drainMedia;
   item.hidden=!active;
   if(!active) item.querySelectorAll('video').forEach(video=>video.pause());
  });
  root.querySelectorAll('[data-drain-media]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));
 }
 const step=event.target.closest('[data-drain-quantity]');
 if(step) {
  const input=step.parentElement.querySelector('input');
  const next=Math.max(Number(input.min)||1,(Number(input.value)||1)+Number(step.dataset.drainQuantity));
  input.value=String(next); input.dispatchEvent(new Event('change',{bubbles:true}));
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    (() => {
  let activeCard = null;
  let activeTouch = null;
  const resetPreview = () => {
    activeCard?.classList.remove('is-touch-preview');
    activeCard = null;
    activeTouch = null;
  };
  document.addEventListener('touchstart', (event) => {
    if (activeCard) return;
    const link = event.target.closest('.product__link');
    const card = link?.closest('.product--has-hover-image');
    const touch = event.changedTouches[0];
    if (!card || !touch) return;
    card.setAttribute('data-touch-preview', '');
    activeCard = card;
    activeTouch = touch.identifier;
    card.classList.add('is-touch-preview');
  }, { passive: true });
  const finishTouch = (event) => {
    if (Array.from(event.changedTouches).some(touch => touch.identifier === activeTouch)) resetPreview();
  };
  document.addEventListener('touchend', finishTouch, { passive: true });
  document.addEventListener('touchcancel', finishTouch, { passive: true });
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    event.target.closest('.product--has-hover-image')?.removeAttribute('data-touch-preview');
  }, { passive: true });
  document.addEventListener('visibilitychange', resetPreview);
  document.addEventListener('shopify:section:unload', resetPreview);
  window.addEventListener('blur', resetPreview);
  window.addEventListener('pagehide', resetPreview);
  window.addEventListener('pageshow', resetPreview);
})();
  } catch(e) { console.error(e); }
})();

})();
